module.exports = __webpack_public_path__ + "static/media/icon-legal-collapsed-white.4222e59c.svg";